import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicBuses = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Buses: Synchronous and Asynchronous - Arbitration"
      videos={[
        "https://www.youtube.com/embed/Yp_3OrDhUkQ",
        "https://www.youtube.com/embed/0GUW00xU9E8"
      ]}
      takeaways={[
        { text: "Just have an overview of this topic; it's not too important." }
      ]}
      questions={[]} // No questions provided
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicBuses;
